import { SideBar } from 'Components/SideBar';
import { Header } from 'Components/Header';
import { Main, SecondColumn } from '../styles';
import { Footer } from 'Components/Footer';
import { useSelector } from 'react-redux';
import { useMenuStatus } from 'store/menu';
import { useAuthTenant } from 'store/auth';
import { useQuery } from 'react-query';
import { getBrandingForDisplay } from 'services/company-service';
import { useEffect } from 'react';

export const LayoutAuthenticated = ({children}) => {
    const openMenu = useSelector(useMenuStatus);
    const tenant = useSelector(useAuthTenant);

    const tenantSlug = tenant?.slug;

    const { data: brandingData } = useQuery(['company-branding', tenantSlug], getBrandingForDisplay, {
        staleTime: 5 * 60 * 1000,
        retry: false,
    });

    // Clear CSS vars immediately when tenant changes, before new data arrives
    useEffect(() => {
        const root = document.documentElement;
        root.style.removeProperty('--color-primary');
        root.style.removeProperty('--color-secondary');
    }, [tenantSlug]);

    useEffect(() => {
        const root = document.documentElement;
        const favicon = document.querySelector('link[rel="icon"]');
        const defaultFavicon = '/favicon.ico';

        const branding = brandingData?.data?.branding;

        if (branding?.primaryColor) {
            root.style.setProperty('--color-primary', branding.primaryColor);
        } else {
            root.style.removeProperty('--color-primary');
        }

        if (branding?.secondaryColor) {
            root.style.setProperty('--color-secondary', branding.secondaryColor);
        } else {
            root.style.removeProperty('--color-secondary');
        }

        if (favicon) {
            favicon.href = branding?.faviconUrl || defaultFavicon;
        }
    }, [brandingData]);

    return (
        <Main>
            <SideBar/>
            <SecondColumn className={openMenu ? 'menu-open' : 'menu-close'}>
                <Header openMenu={openMenu}/>
                <main style={{marginBottom: '40px', position: 'relative'}}>
                    {children}
                </main>
                <Footer/>
            </SecondColumn>
        </Main>
    )
}